export const ONCE_TASK_TYPES = {
  channel_guide: 1, // 进入频道指引
  user_card_guide: 7, // 个人卡片自定义引导
  room_setting_guide: 8, // 房间皮肤自定义引导
  create_room: 9, // 第一次创建房间
  text_channel_intro: 10, // 文字频道介绍
  audio_channel_intro: 11, // 语音频道介绍
  enter_text_channel: 12, // 第一次进入文字频道
  enter_audio_channel: 13, // 第一次进入语音频道
  invite_friend: 14, // 第一次邀请好友
  use_minimal: 15, // 第一次使用极简模式
};

export const SPEAK_FREELY_QUERY_CONFIG_TYPE_MAP = {
  OPEN: "open",
  CLOSE: "close",
};
